import { render, staticRenderFns } from "./MetricIntegration.vue?vue&type=template&id=bb48cd04&scoped=true"
import script from "./MetricIntegration.vue?vue&type=script&lang=js"
export * from "./MetricIntegration.vue?vue&type=script&lang=js"
import style0 from "./MetricIntegration.vue?vue&type=style&index=0&id=bb48cd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb48cd04",
  null
  
)

export default component.exports